import React, { useEffect, useState } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ErrorPage } from "./Areas/Error";
import App from "./app";
import { CookiesProvider } from "react-cookie";
import { getCookieClientAuth } from "Common/cookies";
import paths from "paths";
import api from "Areas/Settings/users/redux/api";
import { isAxiosError } from "axios";
import { store } from "App/redux";
import { error } from "App/popupMessage";
import Login from "Areas/Login";
import "./configs";
function Main() {
    const wrapper = document.querySelector("#content");
    const companyName = (wrapper === null || wrapper === void 0 ? void 0 : wrapper.getAttribute("data-companyName")) || "";
    const productName = (wrapper === null || wrapper === void 0 ? void 0 : wrapper.getAttribute("data-productName")) || "";
    const [isAccessed, setIsAccessed] = useState(false);
    useEffect(() => {
        const checkAuth = async () => {
            var _a, _b, _c, _d;
            const clientAuthCookie = getCookieClientAuth();
            const currentPath = window.location.pathname;
            if (currentPath === paths.login) {
                setIsAccessed(true);
                return;
            }
            if (!clientAuthCookie) {
                window.location.href = paths.login;
                return;
            }
            try {
                const { data } = await api.clientAuth();
                if ((data === null || data === void 0 ? void 0 : data.Id) !== (clientAuthCookie === null || clientAuthCookie === void 0 ? void 0 : clientAuthCookie.Id) ||
                    (data === null || data === void 0 ? void 0 : data.Login) !== (clientAuthCookie === null || clientAuthCookie === void 0 ? void 0 : clientAuthCookie.Login) ||
                    (data === null || data === void 0 ? void 0 : data.Permissions) !== (clientAuthCookie === null || clientAuthCookie === void 0 ? void 0 : clientAuthCookie.Permissions)) {
                    window.location.href = paths.login;
                }
            }
            catch (axiosError) {
                if (isAxiosError(axiosError)) {
                    const errorMessage = (_c = (_b = (_a = axiosError.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message) !== null && _c !== void 0 ? _c : "";
                    store.dispatch(error(errorMessage, false));
                    if (((_d = axiosError.response) === null || _d === void 0 ? void 0 : _d.status) === 401) {
                        window.location.href = paths.login;
                    }
                }
            }
            finally {
                setIsAccessed(true);
            }
        };
        checkAuth();
    }, []);
    if (!isAccessed) {
        return React.createElement("div", null);
    }
    return (React.createElement(CookiesProvider, { defaultSetOptions: { path: "/" } },
        React.createElement(BrowserRouter, null,
            React.createElement(Routes, null,
                React.createElement(Route, { path: paths.app, element: React.createElement(App, { companyName: companyName, productName: productName }) }),
                React.createElement(Route, { path: paths.error, element: React.createElement(ErrorPage, null) }),
                React.createElement(Route, { path: paths.login, element: React.createElement(Login, { error: "", returnUrl: "", hash: window.location.hash, companyName: companyName }) })))));
}
export default Main;
